export const createQueryString = (data: { [key: string]: string }): string => {
  let str = ''
  Object.keys(data).forEach(key => {
    const val = data[key]
    if (val !== undefined) {
      if (val !== null && typeof val === 'object') {
        str += createQueryStringNested(val, key)
      } else {
        str = str.concat(`${key}=${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}&`)
      }
    }
  })
  return str.length > 0 ? '?' + str.slice(0, -1) : str
}

export const createQueryArrayToString = (
  data: string[],
  param: string,
  isConcat = false,
): string => {
  let str = ''
  data.forEach(key => {
    str = str.concat(`${param}=${encodeURIComponent(`${key}`.replace(/\s/g, '_'))}&`)
  })
  return str.length > 0 ? (isConcat ? '&' : '?') + str.slice(0, -1) : str
}

export const createQueryStringNested = (
  data: { [key: string]: string },
  padre: string,
): string => {
  let str = ''
  Object.keys(data).forEach(key => {
    const val = data[key]
    if (val !== undefined)
      str = str.concat(
        `${padre}.${key}=${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}&`,
      )
  })
  return str
}
